import { IGetAdminsListDTO } from '@/models/users.model';
import { Roles } from '@/models/admins.model';

class GetAdminsListDTO implements IGetAdminsListDTO {
  role?: Roles;
  name?: string;
  email?: string;
  page: number;
  limit?: number;
  active?: '0' | '1';
  hidden?: '0' | '1';
  phone?: string;
  verified_at?: string;
  last_login_at?: string;
  title?: string;
  store_title?: string;

  constructor({
    roleName,
    name,
    email,
    page,
    size,
    active,
    hidden,
    phone,
    verified_at,
    last_login_at,
    title,
    store_title,
  }: {
    roleName?: string;
    name?: string;
    email?: string;
    page?: number;
    size?: number;
    active?: '0' | '1';
    hidden?: '0' | '1';
    phone?: string;
    verified_at?: string;
    last_login_at?: string;
    created_at?: string;
    title?: string;
    store_title?: string;
  }) {
    this.role = roleName as Roles;
    this.name = name;
    this.email = email;
    this.limit = size;
    this.page = page ?? 1;
    this.limit = 10;
    this.active = active;
    this.hidden = hidden;
    this.phone = phone;
    this.verified_at = verified_at;
    this.last_login_at = last_login_at;
    this.title = title;
    this.store_title = store_title;
  }
}

export default GetAdminsListDTO;
